module.exports = __webpack_public_path__ + "img/0ea84acea2cdd777e7f71a252c0c82c1.png";